"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var CustomDatePickerWidget_1 = require("./CustomDatePickerWidget");
var moment = require("moment/moment");
var services_1 = require("@falcon/services");
var CustomDatePickerWithExpiryDateWidget = /** @class */ (function (_super) {
    __extends(CustomDatePickerWithExpiryDateWidget, _super);
    function CustomDatePickerWithExpiryDateWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.renderExpiryDateLabel = function () {
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: _this.props.interaction.headerInfo.endDate &&
                    (0, jsx_runtime_1.jsxs)("label", { className: _this.getSetting('expiryDateCssClass', 'cover-expiry-date'), children: ["Cover expiry date:", ' ', (0, jsx_runtime_1.jsx)("span", { className: "font-weight-light", children: moment(_this.props.interaction.headerInfo.endDate, moment.ISO_8601).utc().format("DD MMM YYYY, HH:mm") })] }) }));
        };
        return _this;
    }
    CustomDatePickerWithExpiryDateWidget.prototype.render = function () {
        return _super.prototype.render.call(this);
    };
    CustomDatePickerWithExpiryDateWidget.prototype.renderInputField = function () {
        var _a;
        var isHomeQuote = ((_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.product) === services_1.ProductsEnum.HOME;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-control-datepicker", children: [!isHomeQuote && ((0, jsx_runtime_1.jsx)("b", { className: "mb-2", children: "Cover start date" })), _super.prototype.renderInputField.call(this), this.renderExpiryDateLabel()] }));
    };
    return CustomDatePickerWithExpiryDateWidget;
}(CustomDatePickerWidget_1.CustomDatePickerWidget));
exports.default = CustomDatePickerWithExpiryDateWidget;
//# sourceMappingURL=CustomDatePickerWithExpiryDateWidget.js.map